<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'copyOrderInvoice' })"
      @prev-step="$router.push({ name: 'copyOrderPickUp' })"
    ></next-prev-menu>

    <deliver
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      :returnText="true"
      @updateOrder="updateOrder"
    >
    </deliver>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useCopyOrderStore } from '@/features/copyOrder/CopyOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import Deliver from '@/components/Deliver.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    Deliver
  },
  methods: {
    updateOrder(val) {
      this.copyOrderStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useCopyOrderStore),
    orderDetails() {
      return this.copyOrderStore.orderDetails
    },
    shop() {
      return this.copyOrderStore.shop
    },
    dates() {
      return this.copyOrderStore.deliveryDates
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
